import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, IsBoolean, IsArray, IsOptional, ValidateNested } from "class-validator";
import GenericTableResponse from "../GenericTableResponse";

export class Report {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsOptional()
  @IsBoolean()
  isSet!: boolean | null;
}

export class ReportTree {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsArray()
  children!: Array<ReportTreeItem>;
}

export class ReportTreeItem {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  filterName!: string;
  @Expose()
  @IsArray()
  generatorTypes!: Array<string>;
}

export class ReportModel {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  fileId!: string;
  @Expose()
  @IsString()
  fromDate!: string;
  @Expose()
  @IsString()
  toDate!: string;
  @Expose()
  @IsString()
  fileExtension!: string;
  @Expose()
  @IsString()
  description!: string;
  @Expose()
  @IsString()
  culture!: string;
  @Expose()
  @IsString()
  createdAt!: string;
  @Expose()
  @IsString()
  createdBy!: string;
}

export class ShowReportsResponse extends GenericTableResponse<ReportModel> {
  @Type(() => ReportModel)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<ReportModel>;
}
